module.exports = __webpack_public_path__ + "img/Frame 5136.f85716fe.jpg";